import { createNavigationContainerRef, StackActions } from '@react-navigation/native';
export const navigationRef = createNavigationContainerRef();
import { history } from './RouterHelper';

export function navigate(name, params) {
  if(name==="Home" || name === "home"){
    name = "Dashboard"
  }
  history.navigate(`/${name}`,{state:params});

}

export function push(...args) {
  if (navigationRef.isReady()) {
    navigationRef.dispatch(StackActions.push(...args));
  }
}
export function replace(name, params) {
  if (navigationRef.isReady()) {
    navigationRef.navigate(name, params);
  }
}

export default {
  navigationRef,
  navigate,
  push,
  replace
}
